import VueApexCharts from 'vue3-apexcharts'
export default defineNuxtPlugin((nuxtApp) => {
  // @ts-expect-error - Unsure what's going on here
  nuxtApp.vueApp.use(VueApexCharts)
})
